import React, { ReactNode } from 'react';

import { Icon } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import Link, { IInLineLinkProps, ILinkProps } from 'components/link';
import { Box, Typography } from 'components/ui';
import { NewBadgeIcon } from 'pages/account/icons/new-badge-icon';
import { CustomEventNames } from 'state/amplitude';
import { t } from 'state/intl/translations';
import { primitive, spacing } from 'styles/constants';
import { hiddenAccessibilityPlatformProps } from 'utils/accessibility';

const StyledLink = Link.withConfig({
  borderBottomWidth: '1px',
  borderStyle: 'solid',
  borderBottomColor: `${primitive.$greyFour}`,
  width: '100%',
  color: primitive.$greyOne,
  paddingX: '0',
  paddingY: '5',
  _web: {
    cursor: 'pointer',
  },
});

interface AccountLinkProps {
  link: string;
  label: string;
  testID?: string;
  showNewBadge?: boolean;
  leftIcon: ReactNode;
  linkProps?: IInLineLinkProps | ILinkProps;
}

export const AccountLink = ({
  link,
  label,
  leftIcon,
  linkProps,
  testID,
  showNewBadge,
}: AccountLinkProps) => {
  const Badge = () => (
    <Box style={styles.badgeContainer}>
      <Box style={styles.badgeIcon}>
        <NewBadgeIcon />
      </Box>
      <Typography fontSize="sm">{t('new')}</Typography>
    </Box>
  );

  return (
    <StyledLink
      to={link}
      eventName={CustomEventNames.BUTTON_CLICK_ACCOUNT_INFO}
      testID={testID}
      color={primitive.$bbqBrown}
      justifyContent="space-between"
      {...linkProps}
    >
      <Box style={styles.linkContent}>
        <Box>{leftIcon}</Box>
        <Typography style={styles.label}>{label}</Typography>
        <Box>{showNewBadge && <Badge />}</Box>
      </Box>
      <Icon variant="next" ml="$1" width="4" {...hiddenAccessibilityPlatformProps} />
    </StyledLink>
  );
};

const styles = StyleSheet.create({
  badgeContainer: {
    alignContent: 'center',
    alignItems: 'center',
    backgroundColor: '#D1FAE5',
    borderRadius: 5,
    flexDirection: 'row',
    marginLeft: spacing.$1,
    padding: spacing.$1,
    paddingRight: spacing.$2,
    width: spacing.$14,
  },
  badgeIcon: {
    alignSelf: 'center',
    width: spacing.$4,
  },
  label: {
    alignContent: 'center',
    marginLeft: spacing.$3,
  },
  linkContent: {
    alignItems: 'center',
    flexDirection: 'row',
  },
});
